module.exports = __webpack_public_path__ + "static/2008-plug-0a05cbbe912785a30a366879c0f97af1.jpg";